/**
 * `useSignOut` — mutation that clears the Supabase session + React Query cache.
 *
 * On sign-out we deliberately wipe the whole QueryClient: any hook
 * result built with the previous access token is now invalid, and some
 * endpoints will return 200s with a different payload depending on who's
 * authenticated. Nuking the cache is cheaper than auditing per-key.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { supabase } from "@/lib/supabaseClient";

export function useSignOut() {
  const qc = useQueryClient();
  return useMutation<void, Error, void>({
    mutationFn: async () => {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
    },
    onSuccess: () => {
      qc.clear();
    },
  });
}
